var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 12.2305H17.82C16.84 12.2305 15.97 12.7705 15.53 13.6505L14.69 15.3105C14.49 15.7105 14.09 15.9605 13.65 15.9605H10.37C10.06 15.9605 9.62 15.8905 9.33 15.3105L8.49 13.6605C8.05 12.7905 7.17 12.2405 6.2 12.2405H2.7C2.31 12.2405 2 12.5505 2 12.9405V16.2005C2 19.8305 4.18 22.0005 7.82 22.0005H16.2C19.63 22.0005 21.74 20.1205 22 16.7805V12.9305C22 12.5505 21.69 12.2305 21.3 12.2305Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V10.85C2.22 10.77 2.46 10.73 2.7 10.73H6.2C7.75 10.73 9.14 11.59 9.83 12.98L10.58 14.45H13.44L14.19 12.97C14.88 11.59 16.27 10.73 17.82 10.73H21.3C21.54 10.73 21.78 10.77 22 10.85V7.81C22 4.17 19.83 2 16.19 2ZM10.45 5.41H13.55C13.93 5.41 14.25 5.72 14.25 6.1C14.25 6.49 13.93 6.8 13.55 6.8H10.45C10.07 6.8 9.75 6.49 9.75 6.1C9.75 5.72 10.07 5.41 10.45 5.41ZM14.33 9.59H9.67C9.29 9.59 8.98 9.28 8.98 8.9C8.98 8.51 9.29 8.2 9.67 8.2H14.33C14.71 8.2 15.02 8.51 15.02 8.9C15.02 9.28 14.71 9.59 14.33 9.59Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirect);
export default __webpack_public_path__ + "static/media/direct.bc6e4df550006f26bbc878cdec06ab96.svg";
export { ForwardRef as ReactComponent };